import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert } from "@mui/material";
import { fetchNotifications } from "../../store/slices/dashboard/notificationSlice";
import styles from "./NotificationBanner.module.css";

const NotificationBanner = () => {
  const dispatch = useDispatch();
  const notifications = useSelector((state) => state.notificationState.notifications);

  useEffect(() => {
    dispatch(fetchNotifications());
  }, [dispatch]);

  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className={styles.bannerContainer}>
      {notifications.map((notification) => (
        <Alert 
          key={notification.id} 
          severity="info" 
          className={styles.banner}
        >
          {notification.text}
        </Alert>
      ))}
    </div>
  );
};

export default NotificationBanner;
